export var searchClientDefaults = {
    searchContext: {
        query: '',
        pageSize: 3,
        activeSuggestionIndex: 0,
        inputFocused: false,
        isBackspace: false,
        __typename: 'SearchContext',
    },
};
//# sourceMappingURL=defaults.js.map